import TeamDetailBadge from '@/screens/TeamDetailBadge';

export default function PrivateTabsOrganizationTeamTeamIdBadgeRoute() {
  return <TeamDetailBadge badgePathname="/organization/badge/[badgeId]" />;
}
